import LAYOUT from '@/layouts/default/index.vue';

export default {
  path: '/topic',
  component: LAYOUT,
  name: 'Topic',
  redirect: '/topic/detail',
  meta: {
    title: '话题详情',
  },
  children: [
    {
      path: 'detail',
      name: 'TopicDetail',
      meta: {
        title: '话题详情',
      },
      component: () => import('@/views/topic/detail'),
    },
  ],
};
